<ng-container *ngIf="resetPath.length > 0">
    <div class="col-sm-12">
        <p class="govuk-body">
            <a href="#" class="app-link" (click)="toggleResetForm()">Forgot your password?</a>
        </p>
    </div>
    <ng-container *ngIf="shouldShowPasswordReset">
        <form [formGroup]="passwordResetForm" class="col-sm-12">
            <fieldset class="govuk-fieldset">
                <div class="form-group">
                    <label for="reset-email-form">Email</label>
                    <input class="form-control" id="reset-email-form" name="reset-email-form"
                    type="text" autocomplete="email" placeholder="Enter email address" formControlName="email"
                    tabindex="0" role="textbox">

                    <div *ngIf="resetForm.email.errors" class="invalid-feedback">
                        <div *ngIf="resetSubmitted && resetForm.email.errors.pattern" role="alert" tabindex="0">Email is
                            invalid</div>
                    </div>

                    <div *ngIf="resetForm.email.errors" class="invalid-feedback">
                        <div *ngIf="resetSubmitted && resetForm.email.errors.required" role="alert" tabindex="0">Email is
                            required</div>
                    </div>
                </div>


                <div class="form-group">
                    <button type="submit" class="btn btn-primary btn-max govuk-button button-sizer" role="button" (click)="submitPasswordReset()">
                        Send password reset
                    </button>
                </div>
                <ng-container *ngIf="resetSuccess">
                    <div class="alert alert-success" role="alert">
                        <p>If your email is registered with us, you
                            will receive a password reset email
                            shortly</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="resetError">
                    <div class="alert alert-danger" role="alert">
                        <p>There was a problem attempting to reset your password.</p>
                    </div>
                </ng-container>
            </fieldset>
        </form>
    </ng-container>
</ng-container>